import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface CopyToClipboardButtonProps {
    text: string;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ text }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(text);
    };

    return (
        <Tooltip title="Copy URL">
            <IconButton
                size="small"
                onClick={handleCopy}
                disabled={!text}
            >
                <ContentCopyIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};
